import React, { useRef } from 'react';
import { BiBed, BiBath, BiArea } from 'react-icons/bi';
import { RiHome5Line, RiMapPinLine } from 'react-icons/ri'; 
import { motion, useScroll, useTransform } from 'framer-motion';
import '../styles/House.css';
import { Link } from 'react-router-dom';

const House = ({ house, heightClass }) => {
  const { image, type, country, address, bedrooms, bathrooms, surface, price } = house;

  // Referința pentru containerul principal
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  // Mișcare pe axa Y, dar în mod controlat
  const y = useTransform(scrollYProgress, [0, 1], ["-40%", "20%"]);

  // Clasa pentru înălțimea imaginii, bazată pe heightClass
  const imageHeightClass = heightClass === 'tall-item' ? 'h-[500px]' : 'h-[300px]';

  return (
    <div ref={containerRef} className={`property-details p-[0.2rem] overflow-hidden bg-transparent text-white rounded-lg w-full h-full flex flex-col`}>
    <Link 
    to={`/property/${house.id}`} 
    className="house-link" 
    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
  >
      {/* Containerul pentru imaginea animată */}
      <div className={`relative overflow-hidden h_img_p  ${imageHeightClass}`}> 
        <motion.div 
          className='w-full h-full h-img'
          style={{ y }}>
          <img className='w-full h-full object-cover' src={`${image}`} alt="" />
        </motion.div>
      </div>

      {/* Detalii despre proprietate */}
      <div className='flex gap-x-[1rem] py-2 mt-2'>
        <div className='flex items-center text-white gap-1'> 
          <div className='icons'><RiHome5Line /></div> 
          <div className='text-neutral-300'>{type}</div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='icons'><BiBed /></div>
          <div className='text-neutral-300'>{bedrooms}</div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='icons'><BiBath /></div>
          <div className='text-neutral-300'>{bathrooms}</div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='icons'><BiArea /></div>
          <div className='text-neutral-300'>{surface}</div>
        </div>
      </div>

      <div className='flex py-2 text-white text-lg w-full mb-4'> 
        <div className='icons'><RiMapPinLine /></div> 
        <p className='house_loc truncate'>{address}, {country}</p>
      </div>

      {/* Prețul și butonul */}
      <div className='bottom-row-house flex justify-between items-center mt-auto w-full'>
        <div className='price text-[1.2rem] font-semibold'>
          <span className=''>$</span>{price}
        </div>
        
        <div className="view-btn relative border border-indigo-700 bg-transparent w-5
              px-6 py-[0.3rem] font-medium text-white rounded-full backdrop-blur-xl transition-all duration-500 overflow-hidden
              before:absolute before:inset-0 before:bg-indigo-700 before:scale-x-0 before:origin-left before:transition-transform
              before:duration-500 before:z-[-1] hover:text-white hover:before:scale-x-100"> 
          <p className="text-center whitespace-nowrap text-sm cursor-pointer">Details</p>
        </div>
      </div>
      </Link>
    </div>
  );
}

export default House;
